(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // document.addEventListener("DOMContentLoaded",  function() {
    const button = document.querySelector(".sunzi__button-wrKU7"); 
    if (button) {
      button.style.backgroundColor  = "#FE5D03";
    }
  // });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["page-custom-comments"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.customers-images  img').forEach(img => {
	  img.addEventListener('click',  () => {
	    const modal = document.createElement('div'); 
	    modal.innerHTML  = `
	      <div style="position:fixed;top:0;left:0;width:100%;height:100%;
	        background:rgba(0,0,0,0.8);z-index:999;display:flex;
	        justify-content:center;align-items:center;">
	        <img src="${img.dataset.maximg  || img.src}"  style="max-width:90%;max-height:90%">
	      </div>
	    `;
	    modal.querySelector('div').addEventListener('click',  () => modal.remove()); 
	    document.body.appendChild(modal); 
	  });
	});

    document.addEventListener('DOMContentLoaded',  function() {
    // 所有客户评价数据 
    const customerData = [
        {
            name: "T.R",
            rating: 5,
            comment: "I got this as Christmas gift for my boyfriend. It came out good. The quality of product is amazing. You wind the handle and it changes the picture you picked. So in love",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1.jpg?v=1764138001", 
            productImage: "https://diygiftly.com/cdn/shop/files/7e61a491-0911-4b7b-bcda-599212cc0c02-0_948e8063-8a58-4e3c-8502-c649b27165d0.png?v=1763951614&width=144", 
            productTitle: "Custom Photo Flipbook Frame Animation Machine Mechanical Hand-cranked Flipbook Box Photo Album with Light Black Walnut Anniversary Gifts"
        },
        {
            name: "Dehnhoff.S",
            rating: 5,
            comment: "love how the rings turned out! My sister/best friend share the same birthday month so I gifted one to her and she loved it!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/8Se7VuJJTrAaciEM_6f7d2b06-1a90-4032-8d66-4cf0b84d6f8d.jpg?v=1764138686", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1-81-1296x-1-1800x.webp?v=1764139037", 
            productTitle: "Personalized Birthstone Photo Ring 2 Photo Colors Custom Jewelry Perfect Gift for Her Valentine's Day Gifts"
        },
        {
            name: "Marissa.G",
            rating: 5,
            comment: "I loved these gifts. The music and photo quality it great! I'm going to definitely order more for the holidays. My only issue was that one of my photos had a scratch on them. I took it out the packaging like that, so I'm assuming it happened during it being made, but my other magnet was perfect. Love them so much.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/N1hE06KAd0KWxl8m_d03fddaf-fa01-413e-985b-722f9a2f09d0.jpg?v=1764140339", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P335X02-3.webp?v=1764140509", 
            productTitle: "Custom Music Fridge Magnet Personalized Rectangle Music Fridge Magnet Can Play Songs"
        },
        {
            name: "Cindy.J",
            rating: 5,
            comment: "It's a beautiful bracelet to remember baptism. The company was very professiinal to personalize with my photo.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/tak99aBXQPaCfvWH_ab108201-3743-422b-9ad8-a3e1278474af.jpg?v=1764140591", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/SSL-2294-0007.webp?v=1764140645", 
            productTitle: "Personalized Photo Projection Beads Bracelet With Cross Memorial Gift For Her"
        },
        {
            name: "Tanya.M",
            rating: 5,
            comment: "Beautiful. I had to buffet it but once cleaned, it looks great",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/jbL7mtMDPH6JiYYK_20a482e4-9bc5-4aa1-aa30-23d6e083aa6d.jpg?v=1764144477", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/20220920-142040.webp?v=1764144552", 
            productTitle: "Custom Men's Stainless Steel Bracelet Anniversary Gift For Personalizing Your Special Date"
        },
        {
            name: "Ivan.C",
            rating: 5,
            comment: "Surprised my wife with this and she loved it! Great gift idea!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/UKzryE9rtGEHmWUe_4116d77c-6808-40cd-b216-12db1cb78f72.jpg?v=1764144620", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P206X05.webp?v=1764144737", 
            productTitle: "Personalized 4 Photo Music Fridge Magnet Pro Album Fridge Magnet Music Wall That Can Be Played Photo Sticker Music"
        },
        {
            name: "Raven.S",
            rating: 5,
            comment: "Thank you for the items. They are so cute and my kids loved them. No issue with items.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/nE8rJRLbeejUa6mr_0e3877f2-27cb-432d-8780-965a999d94fa.jpg?v=1764144816", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XHD0P421X16-939badbe-2c55-4f7d-ab65-4078807552a4.webp?v=1764144884", 
            productTitle: "Custom Neon Lamp Personalized Name Neon Sign Adjustable Lamp Creative Decor for Bedroom"
        },
        {
            name: "Melody.F",
            rating: 5,
            comment: "I was so blown away that they had my dad's music as an option after he just recently passed...and it plays the entire song!! I will be buying more and they are the most beautiful and amazing gift... I am so grateful for this... #RememberingSteveFoster",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2fqsufIIGd3zdJ8Y_17f6cef0-7717-44b5-a94a-4a329c77daaf.jpg?v=1764144925", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/BXT0P335X06-3.webp?v=1764145054", 
            productTitle: "Customized Album Fridge Magnet Personalized Rectangle Music Fridge Magnet Can Play Songs"
        },
        {
            name: "Laurie.A",
            rating: 5,
            comment: "I love this, it's a gift for my mom. I just lost my sweet sister. The photo is upside down in the heart but still beautiful, we projected it on the wall",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/IszaI8u7Bfg2graB_d44df6b2-8e70-4d25-a85d-c37f69e0fda1.jpg?v=1764145085", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1-17.webp?v=1764145177", 
            productTitle: "Personalized Angel Photo Ornament Christmas Gifts"
        },
        {
            name: "Gonzalo.C",
            rating: 5,
            comment: "My bf loves it so much. Very unique gift for couples and also for long distance ones.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XgGuVSDCSE65EyO7_e348b452-246e-444d-bac3-9fe32fd312d7.jpg?v=1764145247", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/Black.webp?v=1764145319", 
            productTitle: "Custom Music Fridge Magnet New 4.0 Upgrade Colorful Frame Album Fridge Magnet Music Wall Photo Sticker Music Movement That Can Be Played Gift for Couple"
        },
        {
            name: "Hayden Bartlett",
            rating: 5,
            comment: "I received this gift box with the rose-shaped necklace and I couldn't be happier! The engraved heart necklace is such a beautiful piece of jewellery.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/ZiSynrh6Ha9RuHcU.jpg?v=1764145396", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/XHBPJJ0P467X01.webp?v=1764145496", 
            productTitle: "Engraved Heart Necklace with Real Rose Bear Giftbox Rose Shaped Necklace Gift Box Jewellery Gift Box"
        },
        {
            name: "Lily",
            rating: 5,
            comment: "I am obsessed with this necklace! I got it to hold photos of my children. I love the tone of the opal and the chain is so dainty and beautiful. Highly recommend for a beautiful keepsake!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/LhhRTRlf3URqRCFm_e14ed4fa-715b-4ed8-8f91-859e7e639d7f.jpg?v=1764145572", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/TPNL1354.webp?v=1764145663", 
            productTitle: "Custom Photo Necklace Pearl Surface Creative Pendant Gifts"
        },
        {
            name: "Amber",
            rating: 5,
            comment: "",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_c69b7c57-8ae5-4f75-b91c-954fd97cac6a.webp?v=1764145845", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/681b2a6597235.webp?v=1764145925", 
            productTitle: "My husband loved his personalized bobble head! Great Birthday present!"
        },
        {
            name: "Megi",
            rating: 5,
            comment: "The chain and pendant itself are great quality! I did get this as a gift for my boyfriend and it did not fit his neck but I suspected that it wouldn’t so I had an extender ready. The photo is super clear and exactly what I was hoping for, this was such a meaningful gift. It arrived a few days late, which is in no way the seller’s fault! The seller had great communication before and after the necklace was shipped. I would just say to avoid late arrival, order in advance if it is gift.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/iap_300x300.5008293223_m3bl5qqy.webp?v=1764147205", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/TYNL1193.webp?v=1764147290", 
            productTitle: "Circle Pendant Personalized Photo Projection Necklace Custom Cute Jewelry Anniversary Gifts"
        },
        {
            name: "Kerry",
            rating: 5,
            comment: "So happy with this beautiful bracelet. Either looking to the sun or flashing the light projects the photo.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3_5f2dc69b-c6fd-4b1d-af32-46ea14877c05.webp?v=1764147375", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3.3.webp?v=1764147489", 
            productTitle: "Custom Photo Projection Bracelets Simple Woven Father's Day Gifts"
        },
        {
            name: "Suzzie",
            rating: 5,
            comment: "Very good quality product Finish and photo really well done Thank you very much Very fast shipping in addition!!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4_33e6a05f-b53a-481e-b009-625461add66b.webp?v=1764148252", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4.4.jpg?v=1764148319", 
            productTitle: "Custom Photo Engraved Wallet  Shadow Leather Simple Gifts"
        },
        {
            name: "Brandon",
            rating: 5,
            comment: "I love my phone case!! It is very well made, actually better than I expected! The picture I provided was clear and perfectly positioned, and the case protects my phone all the way around. soufeel answered my questions quickly and I received my product in good time . I highly recommend this business!",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/3_099a7285-6dda-4bff-a1aa-92d51e93ce9a.webp?v=1764148388", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/8_40097ac8-afaf-4300-bd3c-5b0068c020a1.webp?v=1764148446", 
            productTitle: "Custom Spotify Code Music iPhone Case with Text Scannable Engraved Custom Music Song Tempered Glass  - Black"
        },
        {
            name: "Hailey",
            rating: 5,
            comment: "It’s beautiful. Can’t speak more for that. I think it’s the perfect present. High quality and no sharp edges! I like the size it’s not big or too small. The numbers are legible. Fast shipping and replies very quick to questions and concerns. A++++",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4_96adbf40-2fd8-4c34-a99d-fe49e5dad965.webp?v=1764148505", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/44_bce58925-69b4-46ba-a470-e3408b90a1a9.webp?v=1764148560", 
            productTitle: "Personalised Calendar Keychain, Date Keychain, Anniversary, Boyfriend, Girlfriend, Husband, Wife, Relationships, Wedding"
        },
        {
            name: "Vanessa Turner",
            rating: 5,
            comment: "When I received the item I was blown away at how well it turned out and how good of quality it was. My boyfriend loved his gift! Also, the communication was thorough throughout the entire process. It was friendly, professional, attentive, and encouraging. I highly recommend this product/ seller.",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_c69d0e2b-8d40-4114-bd86-8cd1be61f92a.webp?v=1764148623", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/22.webp?v=1764148675", 
            productTitle: "Custom Leather Photo Text Keychain Anniversary Gift For Boyfriend With Engraved Text"
        },
        {
            name: "Rebecca Maiden",
            rating: 5,
            comment: "I purchased the photo watch charm for my husband. The seller responded to all my questions/request very quickly as well as received the product within 2 week. My husband and I love it very much! I would definitely recommend soufeel to everyone.. A++++++",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/1_3b596baa-054c-4920-8350-098cbaae6e27.webp?v=1764148727", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/6_4d53058a-8bd3-4476-bc91-8773402ac22b.webp?v=1764148778", 
            productTitle: "Engraved Men's Black Alloy Bracelet Photo Watch To My Dad I Love You Gifts for Him"
        },
        {
            name: "Lisa Reaves",
            rating: 5,
            comment: "This was a gift for my 17 year old after losing my husband and his father unexpectedly and suddenly three days after he turned 17. He says it’s perfect and it loves it!! I reminder he is always with him!! They did a beautiful job and I will be ordering another one for myself :)",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_dbb61a22-ef82-43ee-849e-a6b168dd40b6.webp?v=1764148858", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/22_379090bd-c3a7-4183-9404-42d0befaecce.webp?v=1764148909", 
            productTitle: "Custom Photo And Engraved Stainless Steel Bracelet Best Gifts for Men Gift For Couple"
        },
        {
            name: "Carrie",
            rating: 5,
            comment: "Just amazing The 3 name ring is just perfect I got soooooooo many compliments already Thank you so much",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/4.webp?v=1764148966", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/9_92170164-4a03-44cc-a184-4e04d4497330.webp?v=1764149019", 
            productTitle: "Three Name Ring 14K Gold Plated Silver"
        },
        {
            name: "JulesIz",
            rating: 5,
            comment: "Absolutely stunning!!! The code scans perfectly and the picture came out so clear. It’s going to be a perfect graduation gift for my best friend",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2_3bc39705-c320-46dd-82c0-f11bf6a0f058.webp?v=1764149076", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/2.2.webp?v=1764149125", 
            productTitle: "Custom Music Code Music Plaques Keychain, Engraved Custom Acrylic, Song Keychain Birthday Valentine's Day Gift"
        },
        {
            name: "Amberj",
            rating: 5,
            comment: "I had my chain for 4 years now still holding up great thanks",
            userImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/5_72fe758d-cbf1-4228-9a94-6af455784aaa.webp?v=1764149180", 
            productImage: "https://cdn.shopify.com/s/files/1/0717/7810/7559/files/55_18ba8a6c-5d8b-40f6-80f7-5b10cba88dc0.webp?v=1764149235", 
            productTitle: "Men's Photo Tag Necklace With Engraving Stainless Steel"
        }
    ];
 
    const container = document.getElementById('customers-container'); 
    const loadMoreBtn = document.getElementById('load-more-btn'); 
    let currentIndex = 0;
    const itemsPerLoad = 10;
 
    // 初始加载 
    loadInitialItems();
 
    // 加载更多函数 
    function loadInitialItems() {
        loadItems(itemsPerLoad);
    }
 
    function loadMoreItems() {
        loadItems(itemsPerLoad);
    }
 
    function loadItems(count) {
        const endIndex = Math.min(currentIndex  + count, customerData.length); 
        
        for (let i = currentIndex; i < endIndex; i++) {
            const item = customerData[i];
            container.appendChild(createCustomerItem(item)); 
        }
        
        currentIndex = endIndex;
        updateButtonState();
    }
 
    function createCustomerItem(item) {
        const li = document.createElement('li'); 
        li.className  = 'customer-items';
        li.innerHTML  = `
            <div class="review-close-new"><i class="photofont icon photo-close"></i></div>
            <div class="customers-images">
                <img src="${item.userImage}"  data-maximg="${item.userImage}"  class="imagesmax" loading="lazy">
            </div>
            <div class="content-right">
                <div class="customers-international">
                    <div class="customers-tittle">
                        ${item.name}  <span class="circle-right"></span>
                    </div>
                    <div class="customers-start">
                        ${'<span class="photofont icon photo-iconfontstart"></span>'.repeat(item.rating)} 
                    </div>
                    <div class="customers-content">${item.comment}</div> 
                </div>
                <div class="customers-product">
                    <div class="review-product-preview">
                        <img src="${item.productImage}" alt="${item.productTitle}" loading="lazy">
                        <div class="customers-modal-layout">
                            <span>${item.productTitle}</span> 
                        </div>
                    </div>
                </div>
            </div>
        `;
        return li;
    }
 
    function updateButtonState() {
        if (currentIndex >= customerData.length)  {
            loadMoreBtn.disabled  = true;
            loadMoreBtn.textContent  = 'NO MORE REVIEWS';
        }
    }
 
    // 确保按钮点击事件绑定正确 
    loadMoreBtn.addEventListener('click',  loadMoreItems);
});
  } catch(e) { console.error(e); }
})();

})();
